import { LoadablePaint } from '@confluence/loadable';

export const ContentReportTableMacroHandler = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContentReportTableMacro" */ '../src/ContentReportTableMacroRenderer.tsx'
			)
		).ContentReportTableMacroRenderer,
});
